import { Tag, Typography } from 'antd'
import itemClasses from '../../domain/itemClasses'
import { centsToDollarsDisplay, percentageDisplay } from '../displayFormatters'

const renderContent = (attribute, firstColumn) => (value, row) => {
  const { oldValue, newValue } = convertValue(attribute, value)

  if (Array.isArray(newValue)) {
    return renderList(firstColumn && row && row.new, oldValue, newValue)
  } else {
    return renderText(firstColumn && row && row.new, oldValue, newValue)
  }
}

const renderText = (isNew, oldValue, newValue) => {
  if (oldValue) {
    return <>
      <Text delete disabled>{oldValue}</Text>
      {newValue !== null && <Text type="secondary"> &#8594; </Text>}
      {newValue}
    </>
  }

  if (isNew) {
    return <><Text>{newValue}</Text> <Tag color="green">New</Tag></>
  }

  return newValue
}

const renderList = (isNew, oldList, newList) => {
  const newTags = newList.map(value => <Tag color='blue' key={value}>{value}</Tag>)

  if (oldList && oldList.length > 0 && newList.length > 0) {
    const updatedOldList = oldList.filter(item => !newList.includes(item))
    const oldTags = updatedOldList.map(value => <Tag color='default' key={value}><Text delete disabled>{value}</Text></Tag>)
    return <>{oldTags}{newTags}</>
  }

  if (isNew) {
    return <>{newTags} <Tag color="green">New</Tag></>
  }

  return <>{newTags}</>
}

const noopConverter = value => value
const currencyConverter = value => centsToDollarsDisplay(value)
const percentageConverter = value => percentageDisplay(value)
const classConverter = value => itemClasses.find(x => x.value === value).name
const listConverter = value => {
  if (value && value !== 'null' && value.split) {
    return value.split(',').map(arrayItem => arrayItem.trim())
  }
  return []
}
const booleanConverter = value => value ? 'true' : 'false'

const { Text } = Typography;

const getConverter = attribute => {
  if (attribute === 'cost' || attribute === 'customPrice') {
    return currencyConverter
  }

  if (attribute === 'tags' || attribute === 'categories') {
    return listConverter
  }

  if (attribute === 'customMargin') {
    return percentageConverter
  }

  if (attribute === 'class') {
    return classConverter
  }

  if (attribute === 'taxable') {
    return booleanConverter
  }

  return noopConverter
}

const convertValue = (attribute, value) => {
  const converter = getConverter(attribute)

  let oldValue = value !== null && (value.oldValue || value.oldValue === false) ? converter(value.oldValue) : null
  let newValue = value != null && typeof (value) === 'object' ? converter(value.newValue) : converter(value)

  // Original values might have been different types (i.e. integer and string) so they would not be equal
  // After conversion they are both strings so compare them one more time.
  // TODO: THIS MIGHT BE FALSE (oldValue = cents, number, newValue dollarsDisplay, string)
  if (oldValue === newValue) {
    oldValue = null
  }

  return { oldValue, newValue }
}

export { convertValue, renderContent }
